import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ExpandableList from 'components/application/ExpandableList';
import InfoBanner from 'components/application/InfoBanner';

import DivisionItem, {
  prepareDivisionItemProps,
} from 'components/riskRegister/sharedResourceNotices/components/shared/DivisionItem';

import { resourceShape } from 'components/helpers/serialisableResources';

export default function MultiCategoriesMultiDivisionsEditable({
  categories,
  divisions,
  riskAssessment,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix:
      'riskRegister.sharedResourceNotices.components.MultiCategoriesMultiDivisionsEditable',
  });

  const { t: i18nTRiskRegister } = useTranslation('common', {
    keyPrefix: 'riskRegister',
  });

  return (
    <InfoBanner title={i18nT('title')}>
      {i18nTRiskRegister('riskAssessmentSharedWith', {
        interpolation: { escapeValue: false },
        riskAssessmentName: riskAssessment.attributes.name,
      })}
      <ExpandableList
        collection={divisions}
        renderItem={(division) => (
          <li key={division.id}>
            <DivisionItem
              {...prepareDivisionItemProps(
                division,
                riskAssessment,
                categories,
              )}
            />
          </li>
        )}
      />
    </InfoBanner>
  );
}

MultiCategoriesMultiDivisionsEditable.propTypes = {
  categories: PropTypes.arrayOf(resourceShape('trade')).isRequired,
  divisions: PropTypes.arrayOf(resourceShape('company')).isRequired,
  riskAssessment: resourceShape('masterActivity').isRequired,
};
